import { observer } from 'mobx-react-lite'

import { StoreReturnsSettings, MsStoresLoadingProps } from '../StoreReturnsSettings'

import { useApi } from '../../../hooks/storeHook'
import { useWbAccount } from '../../../hooks/routeHooks'

export const WildberriesReturnsSettings =
  observer(({msStores, loadMsStores}: MsStoresLoadingProps) => {
    const {userSync: {setWildberriesReturnsSettings}} = useApi()
    const account=useWbAccount()

    return (
      <StoreReturnsSettings
        title="НАСТРОЙКИ ВОЗВРАТОВ"
        msStores={msStores}
        loadMsStores={loadMsStores}
        account={account}
        saveSettings={setWildberriesReturnsSettings}
      />
    )
  })